"use client";

import React, { useState, useEffect } from "react";
import { getUserClients, applyTags, removeTags, getAllTags } from "../../components/http";
import TableTemplate from "../../components/TableTemplate/TableTemplate";
import ClientAddPopup from "./ClientAddPopup";
import Header from "../../components/header/header";
import TagSelector from "./TagSelector";
import Pagination from "../../components/Pagination/Pagination";
import { useTranslation } from "react-i18next";
import styles from "../../components/TableTemplate/TableTemplate.module.scss";
import useNavigator from "../../components/navigator/navigator";

const ClientsPage = () => {
  const { t } = useTranslation();
  const [clients, setClients] = useState([]);
  const [tags, setTags] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isEditingTags, setIsEditingTags] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigator(); 



  const limit = 10;

  useEffect(() => {
    fetchClients(currentPage);
    fetchTags();
  }, [currentPage]);

  const fetchClients = async (page) => {
    setIsLoading(true);
    try {
      const offset = (page - 1) * limit;
      const response = await getUserClients(limit, offset);
      setClients(Object.values(response.data));
      setTotalRecords(response.total_count);
    } catch (error) {
      console.error("Ошибка загрузки клиентов:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTags = async () => {
    try {
      const fetchedTags = await getAllTags();
      setTags(fetchedTags);
    } catch (error) {
      console.error("Ошибка загрузки тегов:", error);
    }
  };

  

  const handleApplyTags = async (clientId, tagsToAdd, tagsToRemove) => {
    try {
      if (tagsToAdd.length > 0) {
        await applyTags([{ client_id: clientId, tags_ids: tagsToAdd }]);
      }
      if (tagsToRemove.length > 0) {
        await removeTags([{ client_id: clientId, tags_ids: tagsToRemove }]);
      }
      fetchClients(currentPage);
    } catch (error) {
      console.error("Ошибка применения тегов:", error);
    }
  };
  
  const headers = [
    t("client.List.client"),
    t("client.List.phoneNumber"),
    t("client.List.passportNumber"),
    t("client.List.source"),
    t("client.List.cars"),
  ];

  const renderRow = (client) => {
    return (
      <>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/clients/client/${client.id}`)}
          className={styles.hyperLink}
          data-label={headers[0]}
        >
          {client.fullname || "-"}
        </div>
        <div className={styles.cell} data-label={headers[1]}>
          {client.phone_number || "-"}
        </div>
        <div className={styles.cell} data-label={headers[2]}>
          {client.passport_number || "-"}
        </div>
        <div className={styles.cell} data-label={headers[3]}>
          {client.source?.join(", ") || "-"}
        </div>
        <div className={styles.cell} data-label={headers[4]}>
          {client.cars?.length ? (
            client.cars.map((car) => (
              <span
                key={car.id}
                className={styles.hyperLink}
                onClick={(e) => {
                  e.stopPropagation(); 
                  navigate(`/cars/${car.id}`);
                }}
              >
                {car.manufacturer} {car.model}
              </span>
            ))
          ) : (
            "-"
          )}
        </div>
      </>
    );
  };
  

  return (
    <>
      <Header title={t("client.List.title")} onAddClick={() => setIsPopupOpen(true)} showImportExport={false} />
      <TableTemplate headers={headers} data={clients} renderRow={renderRow} isLoading={isLoading} path="/clients/client" />
      <Pagination currentPage={currentPage} totalPages={Math.ceil(totalRecords / limit)} onPageChange={setCurrentPage} />
      <ClientAddPopup open={isPopupOpen} onClose={() => setIsPopupOpen(false)} onClientAdded={() => fetchClients(currentPage)} />
    </>
  );
};

export default ClientsPage;
